import React, { useState, useEffect } from 'react';
import PropTypes, { string } from 'prop-types';
import { navigate } from '@reach/router';
import { REQUEST_TYPE } from '../../environment';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import ShowAlert from '../../components/ShowAlert/ShowAlert';
import BorrowerInformation from './BorrowerInformation';
import VerifyOrder from './VerifyOrder';
import StatusService from '../../services/StatusService/StatusService';
import OriginService from '../../services/OriginService/OriginService';
import { formControlClasses } from '@mui/material';


// Define component styling
const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
      padding: theme.spacing(3),
    },
  }
}));

const NewOrderPage = (props) => {
  // Bind styling
  const classes = useStyles();
  const token = JSON.parse(localStorage.getItem('auth'));

  // Initialize state variables
  const [
    initializationInformation,
    setInitializationInformation,
  ] = React.useState(null);
  const [orderStatus, setOrderStatus] = useState(0);
  const [submitPlaceOrder, setSubmitPlaceOrder] = useState(false);


  const [alert, setAlert] = useState({ message: '', severity: 'info', open: false });
  let borrowerObj;
  let verificationType;
  let provider;
  let product
  let loanPurpose
  let primaryContactId
  let resource;


  const handleProviderData = (finalBorrower, BorrowerAuthorization,selectedVerificationType,selectedProviders,selectedProducts,selectedLoanPurposeType) => {
    borrowerObj = {finalBorrower}
    verificationType = selectedVerificationType
    provider = selectedProviders
    product = selectedProducts
    loanPurpose = selectedLoanPurposeType
    // primaryContactId = finalBorrower.borrower[0].id
    primaryContactId = finalBorrower.borrower.find(b => b.isPrimary)?.id;

    
     resource = BorrowerAuthorization && Array.isArray(BorrowerAuthorization)
    ? [].concat(...BorrowerAuthorization.map((innerArray) => innerArray))
    : [];
    


  };

  const host = props.host;

  const initializeOriginInformation = async () => {
    const proxy = await host;
    const originContext = await proxy.getTransactionOrigin();
    const originId = originContext.id;
    const partnerAccessToken = originContext.partnerAccessToken;
    // Initialize application state with origin information
    const origin = OriginService(originId, partnerAccessToken);
    const originLoanData = await origin.getOriginLoanData();
    const originLoanDataDeepMerge = origin.getDeepMerge(originLoanData.data);
    setInitializationInformation(originLoanDataDeepMerge);
  };

  useEffect(() => {
    initializeOriginInformation();
  }, []);

  const getStatusText = () => {
    switch (orderStatus) {
      case 0:
        return 'Verifying Order...';
      case 1:
        return 'Order Processing...';
      case 2:
        return 'Order Failed';
      case 3:
        return 'Order Canceled';
      case 4:
        return 'Order Completed';
      default:
        throw new Error('Unknown status');
    }
  };

  const placeOrder = async () => {

    setSubmitPlaceOrder(true);

    const proxy = await host;
    const transactionResponse = await proxy.createTransaction({
      request: {
        type: REQUEST_TYPE,
        options: {
          VerificationType : verificationType,
          Provider : provider,
          Product : product,
          LoanPurposeType : loanPurpose,
          PrimaryContactId : primaryContactId,
          Borrower: borrowerObj.finalBorrower.borrower,
        },
        resources: resource,
      }
    });

    // Poll for status of transaction processing once created
    const transactionId = transactionResponse.id;
    const statusTracker = StatusService(transactionId, token.token);

    try {
      const currentResponse = await statusTracker.pollStatus();
      const currentStatus = currentResponse.status;
      if (currentStatus === 'Processing') {
        setOrderStatus(1);
      }
      else if (currentStatus === 'Failed') {
        setOrderStatus(2);
      }
      else if (currentStatus === 'Canceled') {
        setOrderStatus(3);
      }
      else if (currentStatus === 'Completed') {
        setOrderStatus(4);
      }

      await new Promise((resolve) => setTimeout(resolve, 2000));
      navigate(`/voie/details/${transactionId}`);
    } catch (err) {
      console.log(err);
    }
  };

  // Render main view
  return (
    <React.Fragment>
      <ShowAlert open={alert.open} message={alert.message} severity={alert.severity} />

      <Paper className={classes.paper}>
        <React.Fragment>

          {submitPlaceOrder === true ? (
            <VerifyOrder submit={true} message={getStatusText()} complete={orderStatus === 0 ? false : true} />
          ) : (
            <BorrowerInformation loan={initializationInformation} host={host} onNext={placeOrder} onProviderData={handleProviderData}  />

          )}
        </React.Fragment>
      </Paper>
    </React.Fragment>
  );
};

NewOrderPage.propTypes = {
  host: PropTypes.object.isRequired,
  originLoanData: PropTypes.object.isRequired
};

export default NewOrderPage;
